import { forwardRef, type FocusEventHandler, type ReactNode } from "react";
import { Input } from "antd";
import type { InputRef } from "antd/es/input";
import { clip } from "../rules";

export const CountedInput = forwardRef<
  InputRef,
  {
    value?: string;
    onChange?: (next: string) => void;
    max: number;
    textarea?: boolean;
    placeholder?: string;
    suffix?: ReactNode;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  }
>(function CountedInput(
  { value, onChange, max, textarea, placeholder, suffix, onBlur },
  ref,
) {
  const text = value ?? "";
  if (textarea) {
    return (
      <div className="relative">
        <Input.TextArea
          ref={ref}
          value={text}
          maxLength={max}
          rows={4}
          placeholder={placeholder}
          className={suffix ? "!pr-8" : undefined}
          onBlur={onBlur}
          onChange={(e) => onChange?.(clip(e.target.value, max))}
        />
        {suffix && <span className="absolute bottom-2 right-2">{suffix}</span>}
      </div>
    );
  }
  return (
    <Input
      ref={ref}
      value={text}
      maxLength={max}
      placeholder={placeholder}
      suffix={suffix}
      onBlur={onBlur}
      onChange={(e) => onChange?.(clip(e.target.value, max))}
    />
  );
});
